import { useEffect, useState } from "react";

const navItems = [
  { href: "#top", label: "首页" },
  { href: "#trending", label: "热榜追踪" },
  { href: "#plaza", label: "话题广场" },
  { href: "#feed", label: "精彩讨论" },
  { href: "#community", label: "社区公约" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 transition-all duration-300">
      <nav
        aria-label="主导航"
        className={
          "w-full transition-all duration-300 " +
          (scrolled
            ? "bg-background-50/90 backdrop-blur-md shadow-[0_2px_20px_-8px_rgba(0,0,0,0.12)]"
            : "bg-transparent")
        }
      >
        <div className="container-x flex items-center justify-between py-3 md:py-4">
          {/* Logo */}
          <a href="#top" className="group flex items-center gap-2.5" aria-label="吃瓜聚集 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 transition-transform duration-300 group-hover:rotate-6">
              <i className="ri-chat-voice-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg font-black tracking-tight text-foreground-950">
                吃瓜聚集<span className="text-primary-500">⚡</span>
              </span>
              <span className="mt-1 text-[10px] font-medium text-foreground-500">全网网友互动专区</span>
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="cursor-pointer rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                {item.label}
              </a>
            ))}
            <a href="#plaza" className="btn-primary ml-3">
              去广场开聊
              <i className="ri-arrow-right-line ml-1 text-sm"></i>
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-foreground-800 lg:hidden"
          >
            <i className={"text-2xl " + (open ? "ri-close-line" : "ri-menu-line")}></i>
          </button>
        </div>

        {/* Mobile menu */}
        <div
          className={
            "overflow-hidden border-b border-background-200 bg-background-50/95 backdrop-blur-md transition-[max-height] duration-300 lg:hidden " +
            (open ? "max-h-96" : "max-h-0")
          }
        >
          <div className="container-x flex flex-col gap-1 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100"
              >
                {item.label}
              </a>
            ))}
            <a href="#plaza" onClick={() => setOpen(false)} className="btn-primary mt-2">
              去广场开聊
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}